<div class="container">
  <mic-breadcrumb id="casing-purchase-details-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/productData/casingPurchase"
      label="{{ translationService.translate('casingPurchaseText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('casingPurchaseSetupText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h3 class="m-0 mt-3" id="casing-purchase-heading">{{ translationService.translate('casingPurchaseSetupText') }}</h3>

  <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="isCreateInProgress">
    <div class="w-full flex flex-row items-center justify-between">
      <form [formGroup]="casingPurchaseDetailsFormGroup" style="display: flex; align-items: flex-start">
        <div style="display: flex; align-items: center; margin-top: 1%">
          <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="edit-component">
            <mat-form-field class="w-full" id="codeField">
              <mat-label class="custom-label-error">{{ translationService.translate('codeText') }} </mat-label>
              <input
                subscriptSizing="dynamic"
                id="code"
                matInput
                type="text"
                required
                form
                formControlName="code"
                (keydown.enter)="$event.preventDefault()"
                (blur)="checkIfCasingPurchaseCodeExists()"
                maxlength="20"
              />
              @if (casingPurchaseDetailsFormGroup.get('code').hasError('required')) {
              <mat-error>{{ translationService.translate('thisIsMandatoryFieldText') }}</mat-error>
              } @if (casingPurchaseDetailsFormGroup.get('code').hasError('exists')) {
              <mat-error>{{ translationService.translate('codeExistsText') }}</mat-error>
              }
            </mat-form-field>
          </div>

          <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
            <mat-form-field class="w-full" id="descriptionField">
              <mat-label class="custom-label-error">{{ translationService.translate('descriptionText') }} </mat-label>
              <input
                subscriptSizing="dynamic"
                id="description"
                matInput
                type="text"
                formControlName="description"
                maxlength="35"
                required
              />
              @if (casingPurchaseDetailsFormGroup.get('description').hasError('required')) {
              <mat-error>{{ translationService.translate('thisIsMandatoryFieldText') }}</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </form>
      <div class="action-bar">
        <button id="cancel" mat-flat-button (click)="cancel()">
          <mat-icon>cancel</mat-icon> {{ translationService.translate('cancelLinkText') }}
        </button>
        <button id="save" type="button" mat-flat-button color="primary" (click)="save()">
          <mat-icon>save</mat-icon>
          {{ translationService.translate('saveLinkText') }}
        </button>
      </div>
    </div>

    <div id="finished-product-table" class="cam-table table-container">
      <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [dataSource]="dataSource">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
        <ng-container *micTableColumnSelector>
          <button mat-flat-button><mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}</button>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'purchasePrice'">
          <input
            subscriptSizing="dynamic"
            id="PurchasePriceInput"
            matInput
            type="text"
            min="0"
            step="0.01"
            pattern="^\\d+(\\.\\d{1,2})?$"
            maxlength="6"
            [formControl]="getControl(item, 'purchasePrice')"
            (keydown)="handleKeydown($event)"
            (input)="restrictTwoDecimalPlaces($event, item)"
          />
        </ng-container>
      </mic-table>
    </div>
  </mic-spinner-overlay>

  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
